import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {UserVerificationService} from '../../services/user-verification.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ApiEndpoints} from "../../services/api-endpoints";

@Component({ standalone: false, 
  selector: 'app-input-dynamic-list',
  templateUrl: './input-dynamic-list.component.html',
})
export class InputDynamicListComponent implements OnInit, OnDestroy {
  public idsArray;
  public idsTempArray = [];
  public isAdmin: boolean = false;
  public inputIsDisable = true;
  public inputIsHidden = false;
  public inputListIsDisable = false;
  public inputListIsHidden = true;
  public noValid = false;
  public patternError = false;
  public disableSaveButtonPattern = false;
  public disableSaveButtonDuplicate = false;
  public disableSaveButtonExist = false;
  public patternMessageError;
  public duplicateMessageError;
  public existMessageError;
  public trackingArr = [];
  public trackingCheck = [];
  public trackingPattern = [];
  public duplicateError = false;
  public hasError = false;
  public netIdExist = false;
  public duplicatesExist = false;
  public idType;
  public noId = false;
  public addRow = true;
  public errorMessage;
  private netIdRegExp = new RegExp(/^([0-9a-fA-F]{6})(\/(1[8-9]|2[0-4]))?$/i);
  private joinEUIRegExp = new RegExp(/^([0-9a-fA-F]{16})(\/(5[8-9]|6[0-4]))?$/i);

  isAdminSubscription: Subscription;

  @Input() validationType;
  @Input() virtId;
  @Input() protocolVersion;
  inputValue: any;
  @Input('inputValueSetter')
  set inputValueSetter(inputValueArray: any) {
    if(inputValueArray) {
      // transform to an array if string is given
      if (typeof inputValueArray === 'string') {
        inputValueArray = this.inputValue.split(',');
      }
      this.inputValue = inputValueArray.map(val => this.removeSuffix(val));
    }
  }

  @ViewChild('inputListCheck', { static: true }) inputListCheck: ElementRef;
  @ViewChild('validate') validate: NgForm;

  @Output() onRemovedNetIDs: EventEmitter<void> = new EventEmitter<void>();

  constructor(private router: Router,
              private _location: Location,
              private userVerificationService: UserVerificationService,
              private http: HttpClient) {
    this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);
  }

  private hex2bin(hex: string, length: number) {
    var mask = "";
    if(hex.length == 16) {
        mask = "00000000000000000000000000000000";
        if(!length) length = 64;
    } else {
        mask = "000000000000";
        if(!length) length = 24;
    }
    //Divide the hex string to two halves and decode each half separately as parseInt hits overflow limits
    var hexAsBinaryLeft = parseInt(hex.substr(0, hex.length / 2), 16).toString(2);
    var hexAsBinaryRight = parseInt(hex.substr(hex.length / 2, hex.length /2), 16).toString(2);
    var hexAsBinaryLeftStr = (mask + hexAsBinaryLeft).substr(-mask.length);
    var hexAsBinaryRightStr = (mask + hexAsBinaryRight).substr(-mask.length);
    var binStr = (hexAsBinaryLeftStr + hexAsBinaryRightStr).substr(0, length);
    return binStr;
  }

  // Validation for NetIds and JoinEuis
  validateId(id, index) {
    this.disableSaveButtonPattern = false;
    this.disableSaveButtonDuplicate = false;
    this.disableSaveButtonExist = false;
    // if the provided netID or joinEUI is empty skip any validation or saving
    if (id === '') {
      this.disableSaveButtonPattern = true;
      return;
    }
    // Pattern validation
    this.patternError = false;
    switch (this.validationType) {
      case 'joinEUI':
        if (!this.joinEUIRegExp.test(id)) {
          this.patternMessageError = "JoinEUI is invalid";
          this.patternError = true;
          this.trackingPattern[index] = true;
        } else {
          this.patternError = false;
          this.trackingPattern[index] = false;
        }
        break;
      case 'netId':
        if (!this.netIdRegExp.test(id)) {
          this.patternMessageError = "NetId is invalid.";
          this.patternError = true;
          this.trackingPattern[index] = true;
        } else {
          this.patternError = false;
          this.trackingPattern[index] = false;
        }
        break;
    }

    if (!this.patternError) {
      // Verify if NetId or JoinEui exists in database
      id = this.addSuffix(id);
      const headers = new HttpHeaders({'Content-Type':  'application/json'});
      let options =  {headers: headers};
      switch (this.validationType) {
        case 'joinEUI':
          this.idType = 'JoinEUi'
          var url = ApiEndpoints.EXISTS_JOIN_EUI;
          var body: any = {
            "virtId": this.virtId,
            "joinEUi": id
          };
          break;
        case 'netId':
          var url = ApiEndpoints.EXISTS_NET_ID;
          this.idType = 'NetId'
          var body: any = {
            "virtId": this.virtId,
            "netId": id
          };
          break;
      }
      this.http.post<any>(url, body, options)
        .subscribe(
           data => {
             this.trackingArr[index] = data.response;
             this.hasError = this.trackingArr[index];
             if (this.hasError === true) {
               this.existMessageError = this.idType + ' already exists in the database!';
             }
           }
        );
    }

    // Verify if exists duplicates
    var prefixLength = parseInt(id.split("/")[1]);
    var prefix = this.hex2bin(id.split("/")[0], prefixLength)

    for (let i = 0; i < this.idsTempArray.length; i++) {
      var tempPrefixLength = parseInt(this.idsTempArray[i].split("/")[1]);
      var tempPrefix = this.hex2bin(this.idsTempArray[i].split("/")[0], tempPrefixLength)
      if ((prefix.startsWith(tempPrefix) || tempPrefix.startsWith(prefix)) && i != index) {
        this.trackingCheck[index] = true;
        break;
      } else {
        this.trackingCheck[index] = false;
      }
    }
    this.duplicateError = this.trackingCheck[index];
    if(this.duplicateError == true) {
      this.duplicateMessageError = "You already entered this " + this.idType;
    }

    // Verify if exists any error

    for(let i in this.trackingPattern) {
      if(this.trackingPattern[i] == true) {
        this.disableSaveButtonPattern = true;
      }
    }
    for(let i in this.trackingCheck) {
      if(this.trackingCheck[i] == true) {
        this.disableSaveButtonDuplicate = true;
      }
    }
    for(let i in this.trackingArr) {
      if(this.trackingArr[i] == true) {
        this.disableSaveButtonExist = true;
      }
    }

  }

  // Validation for last NetId and JoinEui
  validation(inputListCheck) {
    if (inputListCheck !== '') {
      switch (this.validationType) {
        case 'joinEUI':
          if (!this.joinEUIRegExp.test(inputListCheck)) {
            this.patternMessageError = "JoinEUI is invalid";
            this.noValid = true;
          } else {
            this.noValid = false;
          }
          this.hasError = this.noValid;
          break;
        case 'netId':
          this.noValid = false;
          if (!this.netIdRegExp.test(inputListCheck)) {
            this.patternMessageError = "NetId is invalid.";
            this.noValid = true;
          } else {
            this.noValid = false;
          }
          this.hasError = this.noValid;
          break;
      }

      if(!this.hasError) {
        const headers = new HttpHeaders({'Content-Type':  'application/json'});
        let options =  {headers: headers};
        inputListCheck = this.addSuffix(inputListCheck);

        switch (this.validationType) {
          case 'joinEUI':
            this.idType = "JoinEUi";
            var url = ApiEndpoints.EXISTS_JOIN_EUI;
            var body: any = {
              "virtId": this.virtId,
              "joinEUi": inputListCheck
            };
            break;
          case 'netId':
            this.idType = "NetId";
            var url = ApiEndpoints.EXISTS_NET_ID;
            var body: any = {
              "virtId": this.virtId,
              "netId": inputListCheck
            };
            break;
        }
        this.http.post<any>(url, body, options).subscribe(
            data => {
              this.netIdExist = data.response;
              if (this.netIdExist == true) {
                this.hasError = true;
                this.existMessageError = this.idType + " already exists in the database!";
              } else {
                this.hasError = false;
              }
            }
        );
      }

      // Verify if exists duplicates
      var prefixLength = parseInt(inputListCheck.split("/")[1]);
      var prefix = this.hex2bin(inputListCheck.split("/")[0], prefixLength);
      for (let i of this.idsTempArray.map(val => this.addSuffix(val))) {
        var tempPrefixLength = parseInt(i.split("/")[1]);
        var tempPrefix = this.hex2bin(i.split("/")[0], tempPrefixLength)

        if (prefix.startsWith(tempPrefix) || tempPrefix.startsWith(prefix)) {
          this.duplicatesExist = true;
          this.duplicateMessageError = "You already entered this " + this.idType;
          break;
        } else {
          this.duplicatesExist = false;
        }
        this.duplicateError = this.duplicatesExist;
      }
      this.addRow = true;
    } else {
      this.addRow = false;
    }

    this.noId = false;
    if (this.idsTempArray.length === 0 && inputListCheck === '') {
      this.noId = true;
    } else {
      this.noId = false;
    }
  }

  addIds(inputListCheck) {
    this.inputListCheck.nativeElement.value = '';
    this.idsTempArray.push(inputListCheck);
    this.trackingPattern[this.idsTempArray.length - 1] = this.patternError;
    this.trackingArr[this.idsTempArray.length - 1] = this.netIdExist;
    this.trackingCheck[this.idsTempArray.length - 1] = this.duplicatesExist;
    this.validateId(inputListCheck, this.idsTempArray.length - 1);
    this.patternError = this.noValid = this.netIdExist = this.duplicatesExist = false;

    this.noId = false;
    if (this.idsTempArray.length === 0 && inputListCheck === '') {
      this.noId = true;
    } else {
      this.noId = false;
    }
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  editId(index, event) {
    this.idsTempArray[index] = event.target.value;
  }

  removeIds(index, lastRow) {
    this.netIdExist = this.noValid = this.hasError = this.duplicatesExist = this.disableSaveButtonPattern = this.disableSaveButtonDuplicate = this.disableSaveButtonExist = this.patternError = false;
    this.trackingArr.splice(index, 1);
    this.trackingPattern.splice(index, 1)
    this.idsTempArray.splice(index, 1);
    this.trackingCheck.splice(index, 1);
    for (let validateIndex = 0; validateIndex <= this.trackingCheck.length; validateIndex++) {
      if (this.trackingCheck[validateIndex] === true) {
        this.validateId(this.idsTempArray[validateIndex], validateIndex);
      }
    }
    for (let validateIndex = 0; validateIndex <= this.trackingArr.length; validateIndex++) {
      if (this.trackingArr[validateIndex] === true) {
        this.validateId(this.idsTempArray[validateIndex], validateIndex);
      }
    }
    for (let validateIndex = 0; validateIndex <= this.trackingPattern.length; validateIndex++) {
      if (this.trackingPattern[validateIndex] === true) {
        this.validateId(this.idsTempArray[validateIndex], validateIndex);
      }
    }
    this.validation(lastRow);

    this.noId = false;
    if (this.idsTempArray.length == 0 && lastRow == "") {
      this.noId = true;
      this.onRemovedNetIDs.emit();
    } else {
      this.noId = false;
    }
  }

  inputOnClick(inputListCheck) {
    console.log(this.constructor.name, 'inputOnClick', 'inputListCheck', inputListCheck);
    this.netIdExist = this.noValid = this.hasError = this.duplicatesExist = this.disableSaveButtonPattern = this.disableSaveButtonDuplicate = this.disableSaveButtonExist = this.patternError = false;
    inputListCheck.value = "";
    this.inputIsDisable = this.inputListIsHidden = false;
    this.inputIsHidden = this.inputListIsDisable = true;
    if (typeof this.inputValue == 'string') {
      this.idsArray = this.inputValue.split(',');
    } else {
      this.idsArray = this.inputValue;
    }
    console.log(this.constructor.name, 'inputOnClick idsArray', this.idsArray);
    this.idsTempArray = this.idsArray.slice();
  }

  inputOnSave() {
    console.log(this.constructor.name, 'inputOnSave', 'idsTempArray', this.idsTempArray);
    // clean empty values and remove prefixes entered by user
    this.idsTempArray = this.idsTempArray.filter(val => val != null && val !== '').map(id => this.removeSuffix(id));

    // FIXME Why do .slice() ?, it's already an array. Maybe for have a copied/detached instance?
    this.idsArray = this.idsTempArray.slice();
    console.log(this.constructor.name, 'inputOnSave', 'sliced idsArray', this.idsArray);

    // add prefixes
    this.idsArray = this.idsArray.filter(val => val != null && val !== '').map(inputListCheck => {
        console.log(this.constructor.name, 'inputOnSave', 'idsArray map item', inputListCheck);
        inputListCheck = this.addSuffix(inputListCheck);
        return inputListCheck;
    });
    console.log(this.constructor.name, 'inputOnSave', 'idsArray after transformation', this.idsArray);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var url = '';
    var body: any = {};
    switch (this.validationType) {
      case 'netId':
        url = ApiEndpoints.UPDATE_NET_IDS;
        body = {
          "netIds": this.idsArray,
          "virtId": this.virtId
        };
        break;
      case 'joinEUI':
        url = ApiEndpoints.UPDATE_JOIN_EUIS;
        body = {
          "joinEUIs": this.idsArray,
          "virtId": this.virtId
        };
        break;
    }
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.hasError = false
          this.errorMessage = "";
          this.inputValue = this.idsTempArray;
          this.netIdExist = this.noValid = this.duplicatesExist = this.inputIsHidden = this.patternError = false;
          this.inputListIsDisable = false;
          this.inputListIsHidden = true;
          this.trackingPattern = [];
        },
        error => {
          try {
            let err = JSON.parse(error._body);
            this.errorMessage = JSON.stringify(err.Description);
          } catch(ex) {
            this.errorMessage = "An error has occured!"
          } finally {
            this.hasError = true;
          }
        }
      );
  }

  inputOnCancel(inputCheck) {
    this.trackingPattern = [];
    this.idsTempArray = [];
    this.patternError = this.netIdExist = this.duplicatesExist = this.noValid = this.hasError = false;
    this.inputIsDisable = this.inputListIsHidden = true;
    this.inputIsHidden = this.inputListIsDisable = false;
    this.noId = false;
    this.errorMessage = "";
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.isAdminSubscription.unsubscribe();
  }

  private addSuffix(id: any): any {
    if (id !== '') {
      if (id.split('/').length === 1) {
        if (id.length === 6) {
          id += '/24';
        } else if (id.length === 16) {
          id += '/64';
        }
      }
    }
    return id;
  }

  private removeSuffix(id: any): any {
    if (id !== '') {
      const splitted = id.split('/');
      switch (this.validationType) {
        case 'joinEUI':
          if (splitted.length !== 1 && splitted[1] === '64') {
            id = splitted[0];
          }
          break;
        case 'netId':
          if (splitted.length !== 1 && splitted[1] === '24') {
            id = splitted[0];
          }
          break;
      }
    }
    return id;
  }
}
